<mat-drawer-container class="example-container" autosize>
  <!-- <mat-drawer #drawer class="example-sidenav" mode="over" position="end" style="width: 280px">
    <mat-nav-list>
      <a mat-list-item (click)="downloadApp()">Picaggo App </a>
      <div style="position: relative; bottom: 0; width: 100%">
        <a mat-list-item routerLink="/home">Home</a>
        <a mat-list-item target="_blank" href="https://picaggo.com/EULA.html">User Agreement</a>
        <a mat-list-item target="_blank" href="https://picaggo.com/PrivacyPolicy.html">Privacy Policy</a>
        <a mat-list-item (click)="logout()">Logout
        </a>
      </div>
    </mat-nav-list>
  </mat-drawer> -->

  <div class="example-sidenav-content">
    <!-- <div class="container-fluid" style="
    position: sticky;
    top: 0;
    background-image: url('assets/bg_gradient.png'); background-position: top;
    background-position-x: left;
    color: white;
    z-index: 10;
    ">
      <div class="row pt-2 pb-2 align-items-center">
        <div class="col-3">
          <mat-icon class="cursor" (click)="goBack()">keyboard_backspace</mat-icon>
        </div>
        <div class="col-6 text-center">
          <img class="img-icon-css cursor" src="assets/logo white.png" alt="Picaggo" style="padding-bottom: 5px;" />
          <p style="position: relative;font-size: 12px;margin-bottom: 0px;" class="text-uppercase white-color">
            Picaggo
          </p>
        </div>
        <div class="col-3 text-end">
          <mat-icon style="z-index: 1" class="cursor" (click)="drawer.toggle()">menu</mat-icon>
        </div>
      </div>
    </div> -->

    <div class="menu-div">
      <button (click)="goBack()" class="btn back-btn" style="position: absolute; left: 10px; top: 10px; z-index: 10;">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="40" height="40" rx="20" fill="white" />
          <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
          <path d="M28 20H12M12 20L18 14M12 20L18 26" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
      <h2 style="padding: 5px;">Admin Menu</h2>
      <mat-divider></mat-divider>
      <div class="btn-group">
        <button routerLink="/feature-settings" *ngIf="featureSettingsEnabled">
          <mat-icon style="margin-right: 8px;">tune</mat-icon>
          Feature Settings
        </button>
        <!-- <button routerLink="/user-management" *ngIf="userManagementAccess === 1">User Management</button> -->
        <button routerLink="/event-storage" >Storage Analysis</button>
        <button routerLink="/admin" *ngIf="publicAccess === 1">Public Settings</button>

        <button routerLink="/select-photowall" *ngIf="photoWallAccess === 1">Photo Wall Configuration</button>
      </div>
    </div>

  </div>
</mat-drawer-container>